import Form from "./Form";

export default function New() {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="space-y-6">
        <Form />
      </div>
    </div>
  );
}
